import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { categoriesService } from "../services/api";
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CategoriesAddPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      toast.error('Kategori adı gereklidir');
      return;
    }

    setLoading(true);
    const response = await categoriesService.createCategory(formData);
    setLoading(false);

    if (response.success) {
      toast.success('Kategori başarıyla oluşturuldu');
      setTimeout(() => {
        navigate('/categories');
      }, 1000);
    } else {
      toast.error(response.error || 'Kategori oluşturulamadı');
    }
  };

  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Kategori Ekle" />
      <div className="dashboard-main active">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header border-0 pb-0 p-24">
              <h5 className="mb-0">Yeni Kategori Ekle</h5>
            </div>
            <div className="card-body p-24">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      Kategori Adı <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.name}
                      onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                      placeholder="Örn: Kuaför & Güzellik"
                      required
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Açıklama</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={formData.description}
                      onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                      placeholder="Kategori açıklaması (opsiyonel)"
                    />
                  </div>
                  <div className="col-md-12">
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading || !formData.name.trim()}
                      >
                        {loading ? 'Kaydediliyor...' : 'Kategori Ekle'}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => navigate('/categories')}
                      >
                        İptal
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default CategoriesAddPage;
